<template>
<div v-if="commentData" class="post__answer--item">
    <button v-if="!commentData.parentComment" class="post__answer--like" :class="{'post__answer--like-liked': userLike}" @click="likeComment">
        {{commentData.likes.length}}
        <Svg className="post__answer--like-svg" icon="like"/>
    </button>
    <div class="post__answer--response-item">
        <div class="post__answer--text">
            {{commentData.locales && commentData.locales[$store.state.language] ? commentData.locales[$store.state.language].comment : commentData.comment}}
        </div>
        <div class="post__answer--summary">
            <router-link :to="{name:'User', params:{slug:commentData.createdBy._id}}" class="post__answer--author post__answer--summary-item">
                <img :src="`${$store.state.apiUrl}/images/profil/small/${commentData.createdBy.profilePicture.split('.')[0]}.webp`" alt="" class="post__answer--author-img">
                <div class="post__answer--author-text">{{commentData.createdBy.name}}</div>
            </router-link>
            <div class="post__answer--summary-item">
                {{moment(commentData.createdAt).locale($store.state.language).fromNow()}}
            </div>
            <button v-if="commentData.response.length" class="post__answer--summary-item post__answer--hide" @click="toggleComments()">[{{!displayResponses?'+':'-'}}]</button>
            <button class="post__answer--summary-item post__answer--reply" @click="toggleReplyComment">{{displayResponseForm ? t('hide'): t('reply')}}</button>
            <button v-if="commentData.createdBy._id === $store.state.user._id" class="post__answer--summary-item post__answer--delete" @click="deleteComment">{{t('delete')}}</button>
        </div>
        <post-comment-form v-if="displayResponseForm" :collection="collection" :reference="comment.reference" :parentNode="comment._id" @newCommentPost="updateComments"></post-comment-form>
        <div v-if="commentData.response.length && displayResponses" class="post__answer--response">
            <Comment v-for="resp in commentData.response" :key="resp._id" :comment="resp" :collection="collection"/>
        </div>
    </div> 
</div>
</template>

<script>
import {ref, watch} from 'vue';
import moment from 'moment';

import axios from 'axios';
import { useStore } from 'vuex';
import Svg from '@/components/utils/Svg';

import PostCommentForm from '@/components/post/PostCommentForm';
import { useI18n } from 'vue-i18n';

import en from "@/locales/en/comment.json";
import fr from "@/locales/fr/comment.json";

export default {
    components: {PostCommentForm, Svg},
    props:['comment', 'collection'],
    setup(props){
        const {t} = useI18n({
           messages:{
                en: en,
                fr: fr
            }
        });
        const store = useStore();
        const displayResponses = ref(true);
        const displayResponseForm = ref(false);
        const response = ref(null);
        const commentData = ref(props.comment);
        const userLike = ref(commentData.value.likes.includes(store.state.user._id));

        const updateComments = (value) => {
            commentData.value.response.push(value);
            displayResponseForm.value = false;
        }



        const likeComment = async() => {
            const loggedIn = store.state.loggedIn;
            if (loggedIn) {
                try{
                    let method = 'POST';
                    if(userLike.value){
                        method = 'DELETE'
                    }
                    const res = await axios({
                        method,
                        url:'comments/like/'+commentData.value._id
                    })
                    
                    if(res.status == '201' || res.status == '204'){
                        userLike.value = !userLike.value;
                        if(userLike.value){
                            commentData.value.likes.push(store.state.user._id);
                        } else{
                            commentData.value.likes = commentData.value.likes.filter(el => el != store.state.user._id);
                        }
                    }


                }catch(err){
                    console.log(err.response)
                }
            }else{
                store.commit("showSignupPopup");
            }
        }

        
        const deleteComment = async () => {
            store.state.popup.display = true;
            store.state.popup.data = {
                "type": "delete",
                "title": t('popup.title'),
                "subtitle": "",
                "message": t('popup.subtitle'),
                "element": commentData.value.comment,
                "submit": t('popup.cta'),
                "action":{
                    "color": "red",
                    "message": t('popup.action'),
                    "request" :{
                        method: "DELETE",
                        url: 'comments/'+commentData.value._id
                    },
                    "successStatus": 204,
                    "success": {
                        name:"delete-comment",
                    }
                },
            }

            const unwatch = watch( store.state, (newVal, oldVal) => {
                if(newVal.updateData.name === 'delete-comment'){
                    commentData.value = '';
                    store.dispatch('showAction',{message: t('popup.action'), color: 'red'})
                    unwatch();
                    
                }
            })
        }

        const toggleComments = () => {
            displayResponses.value = !displayResponses.value
        }

        const toggleReplyComment = () => {
            displayResponseForm.value = !displayResponseForm.value
        }


        return{
                commentData, 
                deleteComment, 
                displayResponses,
                displayResponseForm, 
                likeComment, 
                moment,  
                response, 
                t,
                toggleComments, 
                toggleReplyComment,
                updateComments,
                userLike
            }
    }
}
</script>

<style lang="scss" scoped>
@import '@/style/main';

.post{
     &__answer{
        &--like{
            @include buttonNoStyle;

            position: absolute;
            right: calc(100% + 2.5rem);
            top: 0;

            border: 1px solid currentColor;
            background-color: $color-white;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.4rem;
            width: 5rem;
            height: 5rem;

            border-radius: 50%;

            // transform: translateX(50%);

            transition: all .2s;
            

            &:hover{
                color:$color-blue-light;

            }

            &-liked{
                color: $color-blue-light;
                animation: like .3s ease-in-out;
            }


            &-svg{
                @include svg(1.4rem);
                margin-left: .6rem;
            }
        }

        &--item{
            position: relative;

            &:not(:last-child){
                margin-bottom: 2rem;
            }
        }
        &--text{
            font-size: 1.4rem;
            margin-bottom: .7rem;
        }
        &--summary{
            display: flex;
            align-items: center;
            font-size: 1.2rem;
            flex-wrap: wrap;
            &-item{
                position: relative;
                margin-bottom: .4rem;
                &:not(:last-child){
                    
                    margin-right: 2rem;
                    &::before{
                        color:currentColor;
                        position: absolute;
                        top: 50%;
                        left: calc(100% + 1rem);
                        content:"\2022";

                        transform: translate(-50%, -50%);
                    }
                }

            }
        }

        &--author{
            display: flex;
            align-items: center;
            position: relative;

            color:inherit;
            text-decoration: none;

            &-text{
                position: relative;
            }
            &:hover > &-text{
                @include hoverUnderline;
            }

            &-img{
                width: 2rem;
                height: 2rem;
                border-radius: 50%;
                margin-right: 1.4rem;
            }
        }

        &--hide{
            @include buttonNoStyle;
            // color:$color-blue-light;
            text-transform: uppercase;
            letter-spacing: .1rem;

            &:hover{
                background-color: $color-blue-light;
                
            }

            &:hover > &-span{
                color:$color-white;
            }
        }

        &--reply{
            @include buttonNoStyle;
            color:$color-blue-light;
            text-transform: uppercase;

            @include hoverUnderline;
            letter-spacing: .1rem;

            
        }

        &--delete{
            @include buttonNoStyle;
            color:$color-red-light;
            text-transform: uppercase;

            @include hoverUnderline;
            letter-spacing: .1rem;
        }

        &--response{
            margin-top: 2rem;
            border-left: 1px solid $color-grey-20;
            padding-left: 2rem;

            &:empty{
                margin-top: 0;
             }
            &-textarea{
                width: 100%;
                height: 6rem;
                // outline: none;
                // t
            }
            &-item{
                margin: 1.8rem 0;
            }
        }
    }
}

</style>